export default __webpack_public_path__ + "static/media/google.8763eeef.svg";